<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'serviceAcceptance' // 受理人信息
}
</script>

<style>

</style>
